export const messages = {
  en: {
    questionTitle: {
      search: {
        title: 'Search Conditions',
        itemTitlePlaceholder: 'Please enter question name',
        titleTypePlaceholder: 'Please select question type',
        pleaseSelect: 'Please select',
        singleChoice: 'Single Choice',
        multipleChoice: 'Multiple Choice',
        shortAnswer: 'Short Answer'
      },
      list: {
        title: 'Questionnaire Questions'
      },
      table: {
        name: 'Name',
        type: 'Type',
        options: 'Options',
        createTime: 'Create Time'
      },
      types: {
        singleChoice: 'Single Choice',
        multipleChoice: 'Multiple Choice',
        shortAnswer: 'Short Answer'
      },
      add: {
        title: 'Add Question',
        name: 'Name',
        namePlaceholder: 'Required, please fill in the name',
        nameRequired: 'Name cannot be empty',
        nameTooLong: 'Name is too long',
        type: 'Type',
        typePlaceholder: 'Required, please select type',
        typeRequired: 'Type cannot be empty',
        option: 'Option',
        optionPlaceholder: 'Required, please fill in the option content',
        optionRequired: 'Option content cannot be empty',
        addOption: 'Add Option',
        removeOption: 'Remove Option',
        pleaseSelect: 'Please select',
        success: 'Added successfully'
      },
      edit: {
        title: 'Edit Question',
        name: 'Name',
        namePlaceholder: 'Required, please fill in the name',
        nameRequired: 'Name cannot be empty',
        nameTooLong: 'Name is too long',
        type: 'Type',
        typePlaceholder: 'Required, please select type',
        typeRequired: 'Type cannot be empty',
        option: 'Option',
        optionPlaceholder: 'Required, please fill in the option content',
        optionRequired: 'Option content cannot be empty',
        addOption: 'Add Option',
        removeOption: 'Remove Option',
        pleaseSelect: 'Please select',
        success: 'Updated successfully'
      },
      delete: {
        title: 'Confirm Operation',
        confirmMessage: 'Are you sure to delete this question?',
        success: 'Deleted successfully'
      },
      fetchError: 'Failed to fetch question data'
    }
  },
  zh: {
    questionTitle: {
      search: {
        title: '查询条件',
        itemTitlePlaceholder: '请输入问题名称',
        titleTypePlaceholder: '请选择题目类型',
        pleaseSelect: '请选择',
        singleChoice: '单选',
        multipleChoice: '多选',
        shortAnswer: '简答'
      },
      list: {
        title: '问卷题目'
      },
      table: {
        name: '名称',
        type: '类型',
        options: '选项',
        createTime: '创建时间'
      },
      types: {
        singleChoice: '单选',
        multipleChoice: '多选',
        shortAnswer: '简答'
      },
      add: {
        title: '添加题目',
        name: '名称',
        namePlaceholder: '必填，请填写名称',
        nameRequired: '名称不能为空',
        nameTooLong: '名称太长',
        type: '类型',
        typePlaceholder: '必填，请选择类型',
        typeRequired: '类型不能为空',
        option: '选项',
        optionPlaceholder: '必填，请填写选项内容',
        optionRequired: '选项内容不能为空',
        addOption: '增加选项',
        removeOption: '删除选项',
        pleaseSelect: '请选择',
        success: '添加成功'
      },
      edit: {
        title: '修改题目',
        name: '名称',
        namePlaceholder: '必填，请填写名称',
        nameRequired: '名称不能为空',
        nameTooLong: '名称太长',
        type: '类型',
        typePlaceholder: '必填，请选择类型',
        typeRequired: '类型不能为空',
        option: '选项',
        optionPlaceholder: '必填，请填写选项内容',
        optionRequired: '选项内容不能为空',
        addOption: '增加选项',
        removeOption: '删除选项',
        pleaseSelect: '请选择',
        success: '修改成功'
      },
      delete: {
        title: '确认操作',
        confirmMessage: '确定删除该题目吗？',
        success: '删除成功'
      },
      fetchError: '获取题目数据失败'
    }
  }
}